/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationConfigResponseBaseResponse as ModelsV3ApplicationApplicationConfigResponseBaseResponse } from '../../models/Models/v3/Application/application-config-response-base-response';

export interface V3PublicApplicationConfigGet$Xml$Params {
  publicAccountId?: string;
  dealershipShortcode?: string;
  origin?: string;
}

export function v3PublicApplicationConfigGet$Xml(http: HttpClient, rootUrl: string, params?: V3PublicApplicationConfigGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationConfigResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3PublicApplicationConfigGet$Xml.PATH, 'get');
  if (params) {
    rb.query('publicAccountId', params.publicAccountId, {});
    rb.query('dealershipShortcode', params.dealershipShortcode, {});
    rb.query('origin', params.origin, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3ApplicationApplicationConfigResponseBaseResponse>;
    })
  );
}

v3PublicApplicationConfigGet$Xml.PATH = '/v3/public/application/config';
